import React from 'react';

/**
 * 성별 구분 없는 기본 아바타 (카카오톡 기본 프로필과 유사한 실루엣).
 */
const DefaultAvatar = ({ className = 'w-14 h-14', title = '기본 프로필 사진' }) => (
  <svg
    viewBox="0 0 64 64"
    className={`overflow-hidden rounded-full ${className}`}
    role="img"
    aria-label={title}
  >
    <title>{title}</title>
    <circle cx="32" cy="32" r="32" fill="#D1D5DB" />
    <circle cx="32" cy="24" r="10" fill="#F3F4F6" />
    <path
      d="M14 54c2.5-11 10.2-16 18-16s15.5 5 18 16"
      fill="#F3F4F6"
    />
  </svg>
);

export default DefaultAvatar;
